import { Component } from "@angular/core";
import { defaultsDeep } from "lodash";
import { takeUntil } from "rxjs/operators";
import { SessionService } from "src/app/session.service";
import { UiService } from "src/app/ui/ui.service";
import { addCommasToNumber } from "src/app/util/util.service";
import { DashboardService } from "../../dashboard.service";
import { GenericWidgetComponent } from "../generic-widget/generic-widget.component";
import { Widget } from "../widgets";

const DEFUALT_PIE_CHART_OPTIONS = {
  grid: {
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
  },
  hover: { mode: null },
  tooltip: {
    trigger: "item",
    formatter: (params: any, ticket: any, callback: any) => {
      return `<strong>${params.name}</strong>
      <br/>Percent: ${params.percent}%
      <br/>Total: ${addCommasToNumber(params.value)}`;
    },
  },
  series: [
    {
      type: "pie",
      radius: ["50%", "80%"],
      labelLine: {
        show: false,
      },
      label: {
        show: false,
      },
      center: ["50%", "42%"],
    },
  ],
};

@Component({
  selector: "app-deliveries-by-category-widget",
  templateUrl: "./deliveries-by-category-widget.component.html",
  styleUrls: ["./deliveries-by-category-widget.component.scss"],
})
export class DeliveriesByCategoryWidgetComponent extends GenericWidgetComponent {
  widget!: Widget;
  deliveriesOptions: any;
  constructor(
    private DashboardService: DashboardService,
    private SessionService: SessionService,
    private uiService: UiService,
  ) {
    super();
  }

  get accountID() {
    return this.SessionService.currentAccountValue!.accountID;
  }

  get accountAppID() {
    return this.SessionService.currentAppValue!.id;
  }

  ngOnInit(): void {}

  ngAfterViewInit() {
    super.ngAfterViewInit();
    this.initData();

    this.filterForm.valueChanges
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe(() => {
        if (
          this.filterForm.valid &&
          this.filterForm.controls.startDate.value <
            this.filterForm.controls.endDate.value
        ) {
          this.initData();
        }
      });
  }

  ngOnDestroy() {
    this.onComponentDestroy.next();
    this.onComponentDestroy.complete();
  }

  initData() {
    this.filterForm.controls.endDate.value.setHours(23, 59, 59);

    this.elementLoader
      .waitForEvent(
        this.DashboardService.getDeliveriesByCategories(
          this.accountID,
          this.accountAppID,
          this.filterForm.controls.startDate.value,
          this.filterForm.controls.endDate.value,
        ),
      )
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe((res) => {
        let categoryCount = 0;

        this.deliveriesOptions = defaultsDeep(
          {
            legend: {
              show: true,
              icon: "circle",
              bottom: 0,
              itemWidth: 12,
              textStyle: {
                width: 58,
                overflow: "truncate",
              },
            },
            series: [
              {
                name: "Deliveries by category",
                data: (res as unknown as any[]).map((category) => {
                  const data = {
                    name: category.category_name,
                    value: category.signals,
                    label: {
                      color: "#FFF",
                    },
                    itemStyle: {
                      color: category.color,
                    },
                  };

                  categoryCount++;
                  return data;
                }),
              },
            ],
          },
          DEFUALT_PIE_CHART_OPTIONS,
        );
      });
  }
}
